const blockSlider = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const blocks = document.querySelectorAll(".block-slider");
        if (!blocks.length) return;

        blocks.forEach((block) => {
            const dataDesk = block.getAttribute("data-desk");
            const dataTablet = block.getAttribute("data-tablet");
            const dataAutoplay = block.getAttribute("data-autoplay");

            let setting = {
                slidesPerView: 1,
                spaceBetween: 10,
                breakpoints: {
                    576: {
                        slidesPerView: dataTablet ? dataTablet : 2,
                        spaceBetween: 50,
                    },
                    992: {
                        slidesPerView: dataDesk ? dataDesk : 4,
                        spaceBetween: 100,
                    },
                },
                pagination: {
                    el: block.querySelector(".swiper-pagination"),
                    clickable: true,
                },
            }

            if (block.classList.contains('white-slides')) {
                setting.centeredSlides = true
                setting.loop = true
                setting.breakpoints[576].spaceBetween = 10;
                setting.breakpoints[992].spaceBetween = 10;
                setting.breakpoints[992].slidesPerView = 'auto';
            }

            if (dataAutoplay && dataAutoplay === '1') {
                setting.autoplay = {
                    delay: 3000,
                };
                setting.loop = true;
            }

            const swiper = new Swiper(block, setting);
        });
    });

}

export default blockSlider;